import Edit from './edit'
import List from './list'
import Create from './create'

export default {
  Edit,
  List,
  Create,
}
